














































































































































































































































































import Vue from 'vue';
import _ from 'lodash';

import moment from 'moment-timezone';
import Requester from '../../requester';
import CustomDialog from '../../components/CustomDialog.vue';
import MedicaoGlicemiaForm from '../../components/medicoes/MedicaoGlicemiaForm.vue';
import MedicaoGlicemiaExcluirForm from '../../components/medicoes/MedicaoGlicemiaExcluirForm.vue';
import MedicaoGlicemiaDados from '../../components/medicoes/MedicaoGlicemiaDados.vue';
import MedicaoGlicemiaDatatable from '../../components/medicoes/MedicaoGlicemiaDatatable.vue';
import MedicaoPressaoArterialForm from '../../components/medicoes/MedicaoPressaoArterialForm.vue';
import MedicaoPressaoArterialExcluirForm from '../../components/medicoes/MedicaoPressaoArterialExcluirForm.vue';
import MedicaoPressaoArterialDados from '../../components/medicoes/MedicaoPressaoArterialDados.vue';
import MedicaoPressaoArterialDatatable from '../../components/medicoes/MedicaoPressaoArterialDatatable.vue';
import { MedicaoGlicemia } from '../../../../back/src/entity/MedicaoGlicemia';
import { tiposMedicoes } from '../../utils/constants';
import { MedicaoPressaoArterial } from '../../../../back/src/entity/MedicaoPressaoArterial';
import { MedicoesQueryObj } from '../../../../back/src/types';

export default Vue.extend({
  name: 'MedicoesIndex',
  components: {
    CustomDialog,
    MedicaoGlicemiaForm,
    MedicaoGlicemiaExcluirForm,
    MedicaoGlicemiaDados,
    MedicaoGlicemiaDatatable,
    MedicaoPressaoArterialForm,
    MedicaoPressaoArterialExcluirForm,
    MedicaoPressaoArterialDados,
    MedicaoPressaoArterialDatatable,
  },
  data() {
    return {
      loading: false,
      tiposMedicoes,
      gestacoes: [],
      dialog: {
        open: false,
        alterar: false,
        excluir: false,
        tipoMedicao: null,
        medicaoGlicemiaSelecionada: null,
        medicaoPressaoSelecionada: null,
      },
      medicoesGlicemia: [],
      medicoesPressaoArterial: [],
      tab: 0,
    };
  },
  async mounted() {
    await this.buscaGestacoes();
    if (this.gestacaoAtual) {
      this.buscaMedicoesGlicemia(this.gestacaoAtual.id);
      this.buscaMedicoesPressaoArterial(this.gestacaoAtual.id);
    } else if (!!this.ultimaGestacao && !this.fimGestacao40Dias) {
      this.buscaMedicoesGlicemia(this.ultimaGestacao.id);
      this.buscaMedicoesPressaoArterial(this.ultimaGestacao.id);
    }
  },
  computed: {
    pacienteId(): number | null {
      return this.$store.getters.usuario ? this.$store.getters.usuario.paciente_id || null : null;
    },
    titleMedicaoDialog() {
      if (this.dialog.excluir) return 'Excluir registro';
      if (this.dialog.alterar) return 'Alterar registro';
      if (this.dialog.medicaoGlicemiaSelecionada || this.dialog.medicaoPressaoSelecionada) {
        if (this.$vuetify.breakpoint.xsOnly) {
          return 'Informações';
        }
        return 'Informações do registro';
      }
      return 'Novo registro';
    },
    gestacaoAtual() {
      return _.find(this.gestacoes, el => el.atual === true);
    },
    ultimaGestacao() {
      return _.maxBy(
        _.filter(this.gestacoes, el => el.parto_id !== null),
        'parto.data_parto',
      );
    },
    fimGestacao40Dias() {
      // verifica se ultima gestacao terminou ha mais de 40 dias
      if (!this.ultimaGestacao) return false;
      const dataFim = moment(this.ultimaGestacao.parto.data_parto);
      const hoje = moment();
      return moment.duration(hoje.diff(dataFim)).asDays() > 40;
    },
    glicemiaDivClass() {
      return `d-flex justify-space-between ${this.$vuetify.breakpoint.xsOnly ? 'flex-column' : ''}`;
    },
  },
  methods: {
    medicaoPressaoArterialCriada(medicao: MedicaoPressaoArterial) {
      this.medicoesPressaoArterial.push(medicao);
      this.resetDialog();
    },
    medicaoPressaoArterialAlterada(medicao: MedicaoPressaoArterial) {
      const index: number = _.findIndex(
        this.medicoesPressaoArterial,
        (el: MedicaoPressaoArterial) => el.id === medicao.id,
      );
      if (index >= 0) {
        this.medicoesPressaoArterial.splice(index, 1, medicao);
      }
      this.resetDialog();
    },
    medicaoPressaoArterialExcluida(medicao: MedicaoPressaoArterial) {
      const index: number = _.findIndex(
        this.medicoesPressaoArterial,
        (el: MedicaoPressaoArterial) => el.id === medicao.id,
      );
      if (index >= 0) {
        this.medicoesPressaoArterial.splice(index, 1);
      }
      this.resetDialog();
    },
    medicaoGlicemiaCriada(medicao: MedicaoGlicemia) {
      this.medicoesGlicemia.push(medicao);
      this.resetDialog();
    },
    medicaoGlicemiaAlterada(medicao: MedicaoGlicemia) {
      const index: number = _.findIndex(
        this.medicoesGlicemia,
        (el: MedicaoGlicemia) => el.id === medicao.id,
      );
      if (index >= 0) {
        this.medicoesGlicemia.splice(index, 1, medicao);
      }
      this.resetDialog();
    },
    medicaoGlicemiaExcluida(medicao: MedicaoGlicemia) {
      const index: number = _.findIndex(
        this.medicoesGlicemia,
        (el: MedicaoGlicemia) => el.id === medicao.id,
      );
      if (index >= 0) {
        this.medicoesGlicemia.splice(index, 1);
      }
      this.resetDialog();
    },
    verMedicaoGlicemia(medicao: MedicaoGlicemia) {
      this.resetDialog();
      this.dialog.medicaoGlicemiaSelecionada = medicao;
      this.dialog.tipoMedicao = tiposMedicoes.GLICEMIA;
      this.dialog.open = true;
    },
    verMedicaoPressao(medicao: MedicaoPressaoArterial) {
      this.resetDialog();
      this.dialog.medicaoPressaoSelecionada = medicao;
      this.dialog.tipoMedicao = tiposMedicoes.PRESSAO;
      this.dialog.open = true;
    },
    cancelarAcao() {
      if (this.dialog.alterar || this.dialog.excluir) {
        this.dialog.alterar = false;
        this.dialog.excluir = false;
      } else {
        this.resetDialog();
      }
    },
    abreDialogNovaMedicaoGlicemia(): void {
      this.resetDialog();
      this.dialog.tipoMedicao = tiposMedicoes.GLICEMIA;
      this.dialog.open = true;
    },
    abreDialogNovaMedicaoPressao(): void {
      this.resetDialog();
      this.dialog.tipoMedicao = tiposMedicoes.PRESSAO;
      this.dialog.open = true;
    },
    excluirMedicao(): void {
      this.dialog.alterar = false;
      this.dialog.excluir = true;
    },
    alterarMedicao(): void {
      this.dialog.excluir = false;
      this.dialog.alterar = true;
    },
    resetDialog() {
      this.dialog.open = false;
      this.dialog.medicaoGlicemiaSelecionada = null;
      this.dialog.medicaoPressaoSelecionada = null;
      this.dialog.excluir = false;
      this.dialog.alterar = false;
      this.dialog.tipoMedicao = null;
    },
    async buscaGestacoes() {
      this.loading = true;
      try {
        const response = await Requester.usuario.gestacoes();
        if (response.errors.length > 0) {
          this.$root.$emit('avisoSnackbar', { color: 'error', text: response.errors });
        } else {
          this.gestacoes = response.data;
        }
      } catch (err) {
        this.$root.$emit('requestError', err);
      } finally {
        this.loading = false;
      }
    },
    async buscaMedicoesGlicemia(gestacaoId: number): Promise<void> {
      const queryObj: MedicoesQueryObj = { gestacao_id: gestacaoId };
      this.loading = true;
      try {
        const response = await Requester.medicaoGlicemia.buscaMedicoes(this.pacienteId, queryObj);
        if (response.errors.length > 0) {
          this.$root.$emit('avisoSnackbar', { color: 'error', text: response.errors });
        } else {
          this.medicoesGlicemia = response.data;
        }
      } catch (err) {
        this.$root.$emit('requestError', err);
      } finally {
        this.loading = false;
      }
    },
    async buscaMedicoesPressaoArterial(gestacaoId: number): Promise<void> {
      const queryObj: MedicoesQueryObj = { gestacao_id: gestacaoId };
      this.loading = true;
      try {
        const response = await Requester.medicaoPressaoArterial.buscaMedicoes(
          this.pacienteId,
          queryObj,
        );
        if (response.errors.length > 0) {
          this.$root.$emit('avisoSnackbar', { color: 'error', text: response.errors });
        } else {
          this.medicoesPressaoArterial = response.data;
        }
      } catch (err) {
        this.$root.$emit('requestError', err);
      } finally {
        this.loading = false;
      }
    },
  },
  watch: {
    dialog: {
      deep: true,
      handler() {
        if (!this.dialog.open) {
          this.resetDialog();
        }
      },
    },
  },
});
